var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfexport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_62_1",
    "data-name": "Component 62 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.305,
    height: 34,
    viewBox: "0 0 29.305 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdficon",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M31.283,8.713,24.241,1.671A.55.55,0,0,0,23.83,1.5H6.763A2.284,2.284,0,0,0,4.5,3.767V14.983a.586.586,0,0,0,1.172,0V3.767A1.091,1.091,0,0,1,6.763,2.676H23.255V9.117a.586.586,0,0,0,.586.586h6.446V33.227A1.091,1.091,0,0,1,29.2,34.318H6.763a1.091,1.091,0,0,1-1.091-1.091V30.222a.586.586,0,1,0-1.172,0v3.013A2.284,2.284,0,0,0,6.763,35.5H29.2a2.284,2.284,0,0,0,2.263-2.263V9.117A.55.55,0,0,0,31.283,8.713Zm-6.852-5.2,5.025,5.036H24.427Z",
    transform: "translate(-2.155 -1.5)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M12.812,17.71H11.78V21.9h1.18a2.509,2.509,0,0,0,1.713-.527,2.016,2.016,0,0,0,.586-1.559C15.213,18.4,14.382,17.71,12.812,17.71Z",
    transform: "translate(-0.903 1.294)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M7.724,17.691H6.67v2.45H7.842a1.559,1.559,0,0,0,1.169-.331,1.332,1.332,0,0,0,.381-.961,1.02,1.02,0,0,0-.4-.9,2.345,2.345,0,0,0-1.269-.255Z",
    transform: "translate(-1.782 1.29)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M27.115,24.323V16.4a1.888,1.888,0,0,0-1.9-1.9H4.4a1.888,1.888,0,0,0-1.9,1.9v7.923a1.888,1.888,0,0,0,1.9,1.9H25.216a1.888,1.888,0,0,0,1.9-1.9ZM10.471,21.11a3.188,3.188,0,0,1-1.993.516H7.388v1.793H6.356V17.3H8.45a3.059,3.059,0,0,1,2.027.539,1.993,1.993,0,0,1,.645,1.641,1.97,1.97,0,0,1-.657,1.629ZM17,22.587a3.681,3.681,0,0,1-2.627.832H12.346V17.3h2.094a3.6,3.6,0,0,1,2.526.815,2.836,2.836,0,0,1,.891,2.215A3.045,3.045,0,0,1,17,22.587Zm6.247-4.324H20.2v1.688h2.708v1h-2.7v2.52H19.18V17.3h4.079Z",
    transform: "translate(-2.5 0.741)",
    fill: "#1a1a1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfexport);
export default __webpack_public_path__ + "static/media/pdfexport.51b07364.svg";
export { ForwardRef as ReactComponent };